// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__209ZI","rootSuccess":"CompleteLink_rootSuccess__2iApX","rootFailure":"CompleteLink_rootFailure__3ZRBJ","isDisabled":"CompleteLink_isDisabled__2AbEe"};